import {  Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-apg-pie-chart',
  templateUrl: './apg-pie-chart.component.html',
  styleUrls: ['./apg-pie-chart.component.scss'],
})
export class ApgPieChartComponent implements OnInit {

  @Input() chartData: { name: string, value: number }[];
  @Input() colorArray: string[];
  @Input() lowValue: number; 
  @Input() highValue: number; 
  @Input() chartDataMode: 'Percentage' | 'ProvidedData' = 'Percentage';
  @Input() label: string;  

  totalValue: number;
  view: any[] = [270, 200];
  showLegend = false;
  showLabels = false;
  animations = false;
  legendPosition = 'below';
  colorScheme = {
    domain: ['#E0E3E8', '#132C40'] 
  }; 

  OnInit()
  {
  }

  calculateSavingsData(lowValue: number, highValue: number) {
    const saving = highValue - lowValue; 
    const percentage = (saving / highValue) * 100; 

    return [
      { name: 'Savings', value: percentage },
      { name: 'Remaining', value: 100 - percentage },
    ];
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['lowValue']?.firstChange || changes['highValue']?.firstChange) {
      setTimeout(() => {
        if(this.colorArray) {
          this.colorScheme = {
            domain:this.colorArray };
          }
        if (this.chartDataMode == 'Percentage')
          this.chartData = this.calculateSavingsData(this.lowValue, this.highValue);
        else if (this.chartData.length > 0) {
          this.totalValue = this.chartData.reduce((acc, data) => acc + data.value, 0);
        }
      });
    }      
  }

  formatAmount()
  { 
    const saving = this.highValue - this.lowValue; 
    const percentage = (saving / this.highValue) * 100; 
    return `${percentage.toFixed(2)}%`;
  }

  labelFormatting(c: any): string {
    const percentage = (c.data.value / this.totalValue) * 100;
    return `${c.label}: ${percentage.toFixed(2)}%`;
  }

  constructor() { }

  ngOnInit() {}
}
